











































































import {Component, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {PrijavaKvara, RadniNalog, StavkaDokumenta, Trebovanje} from "@/services/BackendProxies";
import StavkeServisneOperacije from "../StavkeServisneOperacije.vue";
import StavkeRezervniDelovi from "../StavkeRezervniDelovi.vue";
import TrebovanjeComponent from '../../Trebovanje/Trebovanje.vue';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({components: {'mf-stavke-servisne-operacije': StavkeServisneOperacije, 'mf-stavke-rezervni-delovi': StavkeRezervniDelovi,
        'mf-trebovanje': TrebovanjeComponent}})
export default class InterniRadniNalog extends mixins(ComponentBaseMixin) {
    radniNalog = RadniNalog.fromJS({datum: new Date(), servisneOperacije: [], rezervniDelovi: []});
    trebovanje = new Trebovanje();
    serviseri = [];
    prijavaKvara = new PrijavaKvara();
    isBusy = false;

    dialogTrebovanjeOtvoren = false;

    async created() {
        const serviseri = (await this.loadData(() => dataProxy.vratiServisere())()).map(x => ({id: x.id.toString(), text: `${x.ime} ${x.prezime}`}));
        serviseri.unshift({id: '', text: '...'});
        this.serviseri = serviseri;
    }

    dodajStavkuServisneOperacije(stavka: StavkaDokumenta) {
        this.radniNalog.servisneOperacije.push(stavka);
    }

    async obrisiStavkuServisneOperacije(stavka: StavkaDokumenta) {
        if (stavka.id) {
            await this.deleteData(() => dataProxy.obrisiStavkuDokumenta(stavka.id))();
        }
        this.radniNalog.servisneOperacije = this.radniNalog.servisneOperacije.filter(x => x != stavka);
    }

    onOtvoriTrebovanje() {
        if (!this.radniNalog.id) {
            this.showInfo('trebovanje je moguce kreirati samo za prethodno sacuvan radni nalog');
        } else {
            this.otvoriTrebovanje();
        }
    }

    otvoriTrebovanje() {
        this.trebovanje = Trebovanje.fromJS({radniNalogId: this.radniNalog.id, datum: new Date(), stavke: []});
        this.dialogTrebovanjeOtvoren = true;
    }

    async sacuvajRadniNalog() {
        if (this.isBusy) return;
        this.isBusy = true;
        try {
            this.radniNalog = await this.saveData(() => dataProxy.sacuvajInterniRadniNalog(this.radniNalog))();
        } finally {
            this.isBusy = false;
        }
    }

    async sacuvajTrebovanje() {
        try {
            await (<TrebovanjeComponent>this.$refs.trebovanje).sacuvajTrebovanje();
        } catch (e) {
            this.showError(e);
            this.dialogTrebovanjeOtvoren = true;
        }
    }

    kreirajNov() {
        this.radniNalog = RadniNalog.fromJS({datum: new Date(), servisneOperacije: [], rezervniDelovi: []});
        this.prijavaKvara = new PrijavaKvara();
    }

    @Watch('radniNalog.prijavaKvaraId') async onPrijavaKvaraChanged(id: number) {
        if (id) {
            this.prijavaKvara = await this.loadData(() => dataProxy.vratiPrijavuKvara(id))();
        }
    }

    async onUnetBrojDokumenta(id: number) {
        if (id) {
            const radniNalog = await this.loadData(() => dataProxy.vratiInterniRadniNalogPoId(id))();
            if (!radniNalog) {
                this.showInfo('dokument nije moguce ucitati');
            } else {
                this.radniNalog = radniNalog;
            }
        }
    }

    async zakljuciDokument() {
        if (this.isBusy) return;

        if (this.radniNalog.id) {
            const da = await this.confirmationNeeded('da li zelite da zakljucite dokument');
            if (da) {
                try {
                    this.isBusy = true;
                    await dataProxy.zakljuciInterniRadniNalog(this.radniNalog);
                    this.showInfo('dokument je zakljucen');
                    this.kreirajNov();
                } catch (e) {
                    this.processException(e);
                } finally {
                     this.isBusy = false;
                }
            }
        }
    }
}
